/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { sanitizeRichText } from '@utils/sanitizeHtml';

export const Ta11yText = ({ textContent, className, tag: Tag }) => {
  // check that headingContent is not null/undefined and that headingContent.content is not undefined/empty string
  if (!textContent || !textContent.content) {
    return null;
  }

  return textContent.isHtml ? (
    <Tag
      {...(textContent.hasAriaLabel && { 'aria-label': textContent.ariaLabel })}
      {...(textContent.hasAriaDescription && {
        'aria-description': textContent.ariaDescription
      })}
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeRichText(textContent.content) }}
     />
  ) : (
    <Tag
      {...(textContent.hasAriaLabel && { 'aria-label': textContent.ariaLabel })}
      {...(textContent.hasAriaDescription && {
        'aria-description': textContent.ariaDescription
      })}
      className={className}
    >
      {textContent.content}
    </Tag>
  );
};

export default Ta11yText;
